const formatter = new Intl.DateTimeFormat('ru', {
  dateStyle: 'short',
});

export const formatDate = (date: Date): string | undefined =>
  isNaN(+date) ? undefined : formatter.format(date);
